module.exports = __webpack_public_path__ + "assets/ba8c10ed409fb633ebe638603bb5362c.svg";